import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { getItemsFromCollection, getItemFromCollection } from 'helpers/normalizeHelpers'
import { StreamId } from 'components/features/videoCalls/types/agoraTypes'
import { PermissionsState } from 'components/features/videoCalls/types/state'

const videoCallSelector = (state: State) => state.app.videoCall

const videoDetailsSelector = createSelector(
  videoCallSelector,
  (state) => state.details
)

export const localStreamSelector = createSelector(
  videoCallSelector,
  (state) => state.localStream
)

const peersCollectionSelector = createSelector(
  videoCallSelector,
  (state) => state.peers
)

export const createPeerSelector = () => createSelector(
  peersCollectionSelector,
  (_: State, props: { id: StreamId | null }) => props.id,
  getItemFromCollection
)

const peersSelector = createSelector(
  peersCollectionSelector,
  getItemsFromCollection
)

const firstScreenPeerSelector = createSelector(
  peersSelector,
  (peers) => peers.find((peer) => peer.isScreenShare && peer.streamId && !peer.isLocal) || null
)

const firstVideoPeerSelector = createSelector(
  peersSelector,
  (peers) => peers.find((peer) => !peer.isScreenShare && !peer.isLocal) || null
)

export const mainStreamSelector = createSelector(
  videoDetailsSelector,
  localStreamSelector,
  firstScreenPeerSelector,
  firstVideoPeerSelector,
  ({ speakerStreamId, pinnedStreamId }, { streamId: localStreamId }, screenPeer, videoPeer) => {
    if (pinnedStreamId) {
      return pinnedStreamId
    }

    if (screenPeer) {
      return screenPeer.streamId
    }

    if (speakerStreamId && speakerStreamId !== localStreamId) {
      return speakerStreamId
    }

    if (videoPeer) {
      return videoPeer.streamId
    }

    return localStreamId
  }
)

export function videoCallPermissionsStateSelector (state: State): PermissionsState {
  return videoCallSelector(state).permissions
}
